export enum SellerAccountConformityEnum {
  COMFORM = 'COMFORM',
  PENDING_COMFORMITY = 'PENDING_COMFORMITY',
  NO_COMFORMITY = 'NO_COMFORMITY',
  ERROR_COMFORMITY = 'ERROR_COMFORMITY',
}
